__DL__jQueryinterval = setInterval(function(){
      // wait for jQuery to load & run script after jQuery has loaded
      if(window.jQuery){
          // search parameters
          getURLParams = function(name, url){
              if (!url) url = window.location.href;
              name = name.replace(/[\[\]]/g, "\\$&");
              var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
              results = regex.exec(url);
              if (!results) return null;
              if (!results[2]) return '';
              return decodeURIComponent(results[2].replace(/\+/g, " "));
          };

          /**********************
          * DYNAMIC DEPENDENCIES
          ***********************/

          __DL__ = {
              dynamicCart: true,  // if cart is dynamic (meaning no refresh on cart add) set to true
              debug: false, // if true, console messages will be displayed
              cart: null,
              wishlist: null,
              removeCart: null
          };

          customBindings = {
              cartTriggers: [],
              viewCart: [],
              removeCartTrigger: [],
              cartVisableSelector: [],
              promoSubscriptionsSelectors: [],
              promoSuccess: [],
              ctaSelectors: [],
              newsletterSelectors: [],
              newsletterSuccess: [],
              searchPage: [],
              wishlistSelector: [],
              removeWishlist: [],
              wishlistPage: [],
              searchTermQuery: [getURLParams('q')], // replace var with correct query
          };

          /* DO NOT EDIT */
          defaultBindings = {
              cartTriggers: ['form[action="/cart/add"] [type="submit"],.add-to-cart,.cart-btn'],
              viewCart: ['form[action="/cart"],.my-cart,.trigger-cart,#mobileCart'],
              removeCartTrigger: ['[href*="/cart/change"]'],
              cartVisableSelector: ['.inlinecart.is-active,.inline-cart.is-active'],
              promoSubscriptionsSelectors: [],
              promoSuccess: [],
              ctaSelectors: [],
              newsletterSelectors: ['input.contact_email'],
              newsletterSuccess: ['.success_message'],
              searchPage: ['search'],
              wishlistSelector: [],
              removeWishlist: [],
              wishlistPage: []
          };

          // stitch bindings
          objectArray = customBindings;
          outputObject = __DL__;

          applyBindings = function(objectArray, outputObject){
              for (var x in objectArray) {
                  var key = x;
                  var objs = objectArray[x];
                  values = [];
                  if(objs.length > 0){
                      values.push(objs);
                      if(key in outputObject){
                          values.push(outputObject[key]);
                          outputObject[key] = values.join(", ");
                      }else{
                          outputObject[key] = values.join(", ");
                      }
                  }
              }
          };

          applyBindings(customBindings, __DL__);
          applyBindings(defaultBindings, __DL__);

          /**********************
          * PREREQUISITE LIBRARIES
          ***********************/

          clearInterval(__DL__jQueryinterval);

          // jquery-cookies.js
          if(typeof $.cookie!==undefined){
              (function(a){if(typeof define==='function'&&define.amd){define(['jquery'],a)}else if(typeof exports==='object'){module.exports=a(require('jquery'))}else{a(jQuery)}}(function($){var g=/\+/g;function encode(s){return h.raw?s:encodeURIComponent(s)}function decode(s){return h.raw?s:decodeURIComponent(s)}function stringifyCookieValue(a){return encode(h.json?JSON.stringify(a):String(a))}function parseCookieValue(s){if(s.indexOf('"')===0){s=s.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,'\\')}try{s=decodeURIComponent(s.replace(g,' '));return h.json?JSON.parse(s):s}catch(e){}}function read(s,a){var b=h.raw?s:parseCookieValue(s);return $.isFunction(a)?a(b):b}var h=$.cookie=function(a,b,c){if(arguments.length>1&&!$.isFunction(b)){c=$.extend({},h.defaults,c);if(typeof c.expires==='number'){var d=c.expires,t=c.expires=new Date();t.setMilliseconds(t.getMilliseconds()+d*864e+5)}return(document.cookie=[encode(a),'=',stringifyCookieValue(b),c.expires?'; expires='+c.expires.toUTCString():'',c.path?'; path='+c.path:'',c.domain?'; domain='+c.domain:'',c.secure?'; secure':''].join(''))}var e=a?undefined:{},cookies=document.cookie?document.cookie.split('; '):[],i=0,l=cookies.length;for(;i<l;i++){var f=cookies[i].split('='),name=decode(f.shift()),cookie=f.join('=');if(a===name){e=read(cookie,b);break}if(!a&&(cookie=read(cookie))!==undefined){e[name]=cookie}}return e};h.defaults={};$.removeCookie=function(a,b){$.cookie(a,'',$.extend({},b,{expires:-1}));return!$.cookie(a)}}))}

          /**********************
          * Begin dataLayer Build
          ***********************/

          window.dataLayer = window.dataLayer || [];  // init data layer if doesn't already exist

          var template = "";

          /**
          * Landing Page Cookie
          * 1. Detect if user just landed on the site
          * 2. Only fires if Page Title matches website */

          $.cookie.raw = true;
          if ($.cookie('landingPage') === undefined || $.cookie('landingPage').length === 0) {
              var landingPage = true;
              $.cookie('landingPage', unescape);
              $.removeCookie('landingPage', {path: '/'});
              $.cookie('landingPage', 'landed', {path: '/'});
          } else {
              var landingPage = false;
              $.cookie('landingPage', unescape);
              $.removeCookie('landingPage', {path: '/'});
              $.cookie('landingPage', 'refresh', {path: '/'});
          }
          if (__DL__.debug) {
              //console.log('Landing Page: ' + landingPage);
          }

          /**
          * Log State Cookie */

          
          var isLoggedIn = false;
          
          if (!isLoggedIn) {
              $.cookie('logState', unescape);
              $.removeCookie('logState', {path: '/'});
              $.cookie('logState', 'loggedOut', {path: '/'});
          } else {
              if ($.cookie('logState') === 'loggedOut' || $.cookie('logState') === undefined) {
                  $.cookie('logState', unescape);
                  $.removeCookie('logState', {path: '/'});
                  $.cookie('logState', 'firstLog', {path: '/'});
              } else if ($.cookie('logState') === 'firstLog') {
                  $.cookie('logState', unescape);
                  $.removeCookie('logState', {path: '/'});
                  $.cookie('logState', 'refresh', {path: '/'});
              }
          }

          if ($.cookie('logState') === 'firstLog') {
              var firstLog = true;
          } else {
              var firstLog = false;
          }
          if ($.cookie('logState') === 'firstLog') {
            dataLayer.push({
              'event': 'login',    
              'user_id': '',
              'email' : 'da39a3ee5e6b4b0d3255bfef95601890afd80709'  
             });
          }

        /* Signup */
            var cksignup = getURLParams('signup');
            if(cksignup =='true'){
               dataLayer.push({
              'event': 'signup',    
              'user_id': '', 
              'email': 'da39a3ee5e6b4b0d3255bfef95601890afd80709' 
                                                                 
             });
            var uri = window.location.toString();
        	if (uri.indexOf("?") > 0) {
        	    var clean_uri = uri.substring(0, uri.indexOf("?"));
        	    window.history.replaceState({}, document.title, clean_uri);
        	}
            }

              


          /**********************
          * DATALAYER SECTIONS
          ***********************/

          /**
          * DATALAYER: Landing Page
          * Fires any time a user first lands on the site. */

          if ($.cookie('landingPage') === 'landed') {
              dataLayer.push({
                  'pageType': 'Landing',
                  'event': 'first_time_visitor'
              });
          }

          /**
          * DATALAYER: Log State
          * 1. Determine if user is logged in or not.
          * 2. Return User specific data. */

          var logState = {
              
              'firstLog'      : firstLog,
              'customerEmail' : null,
              'timestamp'     : Date().replace(/\(.*?\)/g,''),
              
              'customerType'       : 'New',
              'customerTypeNumber' :'1',
              
              'shippingInfo' : {
                  'fullName'  : null,
                  'firstName' : null,
                  'lastName'  : null,
                  'address1'  : null,
                  'address2'  : null,
                  'street'    : null,
                  'city'      : null,
                  'province'  : null,
                  'zip'       : null,
                  'country'   : null,
                  'phone'     : null,
              },
              'billingInfo' : {
                  'fullName'  : null,
                  'firstName' : null,
                  'lastName'  : null,
                  'address1'  : null,
                  'address2'  : null,
                  'street'    : null,
                  'city'      : null,
                  'province'  : null,
                  'zip'       : null,
                  'country'   : null,
                  'phone'     : null,
              },
              'checkoutEmail' : null,
              'currency'      : null,
              'pageType'      : 'Log State',
              'event'         : 'logState'
          }
          dataLayer.push(logState);

          /**
          * DATALAYER: Homepage */

          if(document.location.pathname == "/"){
              dataLayer.push({
                  'pageType' : 'Homepage',
                  'event'    : 'homepage',
                  logState
              });
          }

          /**
          * DATALAYER: 404 Pages
          * Fire on 404 Pages */
        	

          /**
          * DATALAYER: Blog Articles
          * Fire on Blog Article Pages */
          

          /** DATALAYER: Product List Page (Collections, Category)
          * Fire on all product listing pages. */
          

          /** DATALAYER: Search page
          * Fire on Search listing pages. */
          

          /** DATALAYER: Product Page
          * Fire on all Product View pages. */
          

          /** DATALAYER: Cart View
          * Fire anytime a user views their cart (non-dynamic) */

          

          /** DATALAYER: Checkout on Shopify Plus Ssers **/

          if(Shopify.Checkout){
              var ecommerce = {
                  'transaction_id': 'null',
                  'affiliation': null,
                  'value': "",
                  'tax': "",
                  'shipping': "",
                  'subtotal': "",
                  'currency': null,
                  


                  'email': null,
                  'items':[],
                  };
              if(Shopify.Checkout.step){
                  if(Shopify.Checkout.step.length > 0){
                      if (Shopify.Checkout.step === 'contact_information'){
                          dataLayer.push({
                              'event'    :'begin_checkout',
                              'pageType' :'Customer Information',
                              'step': 1,
                          	ecommerce
                          });
                      }else if (Shopify.Checkout.step === 'shipping_method'){
                          dataLayer.push({
                              'event'    :'add_shipping_info',
                              'pageType' :'Shipping Information',
                              ecommerce
                          });
                      }else if( Shopify.Checkout.step === "payment_method" ){
                          dataLayer.push({
                              'event'    :'add_payment_info',
                              'pageType' :'Add Payment Info',
                          	ecommerce
                          });
                      }
                  }
              }
          }

  	    /** DOM Ready **/
          $(document).ready(function() {

              /** DATALAYER: Search Results */
              var searchPage = new RegExp(__DL__.searchPage, "g");
              if(document.location.pathname.match(searchPage)){
                  var ecommerce = {
                      items :[],
                  };
                  dataLayer.push({
                      'pageType'   : "Search",
                      'search_term' : __DL__.searchTermQuery,
                      'event'      : "search",
                      'item_list_name'  : null,
                      ecommerce
                  });
              }

              /** DATALAYER: Remove From Cart **/
              

              /** Google Tag Manager **/
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-5G7XJ28');

          }); // document ready
      }
  }, 10000);